module.exports = __webpack_public_path__ + "img/menu.322ec616.jpg";